module.exports = __webpack_public_path__ + "media/images/icon_instagram-d8cbc3b51f225d2d9487fd41123d1e5c.svg";